import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatrollingStatusComponent } from './components/patrol-status/patrolling-status.component';
import { PatrolDetailDrawerComponent } from './components/patrol-detail-drawer/patrol-detail-drawer.component';
import { MaterialModule } from 'src/app/shared/modules/material.module';
import { GoogleMapsModule } from '@angular/google-maps';

@NgModule({
  declarations: [PatrollingStatusComponent, PatrolDetailDrawerComponent],
  imports: [CommonModule, MaterialModule, GoogleMapsModule],
  exports: [PatrollingStatusComponent],
})
export class SecurityPatrolModule {}
